

















import { OpsGenieChannelDetails } from '@/types';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component
export default class OpsGenieIntegration extends Vue {
  @Prop() private integrationDetails!: OpsGenieChannelDetails;
  @Getter private hasPermission!: any;

  private handleErrorChange(value: boolean) {
    this.$emit('validate', !value);
  }
}
